import { ConditionChange } from '../../domain';

export const CONDITION_CHANGES: ConditionChange[] = [
	new ConditionChange(1,'Obesity is reduced'),
	new ConditionChange(2,'Air quality is improved'),
	new ConditionChange(3,'Water quality is improved'),
	new ConditionChange(4,'Californians are more employable'),
	new ConditionChange(5,'Diverse populations are being served')
];
